import React from 'react';
import WYSIWYGArea from 'components/TextArea/WYSIWYGArea';

interface IProps {
	changeDescription: (value: string) => void;
	description: string;
}

export const DescriptionField: React.FC<IProps> = ({ changeDescription, description }) => {
	return <WYSIWYGArea onChange={changeDescription} value={description} testId="DescriptionField" />;
};
